<template>
    <div id="shippingMethods">
        <ButtonGroup
            :buttons="actualShippingMethods"
            name="shippingMethod"
            :value.sync="selectedShipping"
            class="top-buttons"
            required
        />

        <div v-if="showPackagingOptions">
            <template v-if="isGiftBox">
                <div class="row mt-2" v-if="$root.isMobile">
                    <div class="col-12">
                        <ImageFluid
                            :webp-src="require('@/assets/webp/giftbox/giftbox_358x320@1x.webp')"
                            :retinaSrc="require('@/assets/giftbox/giftbox_358x320@2x.jpg')"
                            :src="require('@/assets/giftbox/giftbox_358x320@1x.jpg')"
                            alt="Animod Geschenkbox"
                            img-class="package-image front"
                            width="358"
                            height="320"
                        />
                    </div>
                    <div class="col-12">
                        <p>{{ $t('ShippingMethod.giftbox.headline') }}</p>
                        <small class="d-block mb-1">{{
                            $t('Checkout.message.packagingDomesticOnly')
                        }}</small>
                    </div>
                </div>
                <div class="row mt-2" v-else>
                    <div class="col-sm-4">
                        <ImageFluid
                            :webp-src="require('@/assets/webp/giftbox/giftbox_358x320@1x.webp')"
                            :retinaSrc="require('@/assets/giftbox/giftbox_358x320@2x.jpg')"
                            :src="require('@/assets/giftbox/giftbox_358x320@1x.jpg')"
                            alt="Animod Geschenkbox"
                            img-class="package-image front"
                            width="358"
                            height="320"
                        />
                    </div>
                    <div class="col-sm-8 giftbox-text">
                        <h4>{{ $t('ShippingMethod.giftbox.headline') }}</h4>
                        <CheckList :items="giftboxBulletPoints" />
                        <small class="d-block mb-1">{{
                            $t('Checkout.message.packagingDomesticOnly')
                        }}</small>
                    </div>
                </div>
            </template>
            <template v-else>
                <p>{{ $t('ShippingMethod.post.text') }}</p>
                <small class="d-block mb-1">{{ $t('Checkout.message.packagingDomesticOnly') }}</small>
            </template>
            <p class="xmas-notice mt-2" v-if="showXmasShippingInfo">
                {{ $t('Checkout.shippingMethod.xmas_notice') }}
            </p>
        </div>
    </div>
</template>

<script>
import ButtonGroup from '@/components/ButtonGroup';
import CheckList from '@/components/product/CheckList';
import availableShippingMethods from '@/models/shippingMethods';
import ImageFluid from '@/components/ImageFluid';

export default {
    name: 'ShippingMethodsSelect',
    components: {
        ImageFluid,
        ButtonGroup,
        CheckList
    },
    data() {
        return {
            availableShippingMethods,
            giftboxBulletPoints: [
                this.$t('ShippingMethod.giftbox.bulletpoints.1'),
                this.$t('ShippingMethod.giftbox.bulletpoints.2'),
                this.$t('ShippingMethod.giftbox.bulletpoints.3')
            ]
        };
    },
    props: {
        //Backend provided shipping methods
        shippingMethods: {
            type: Object,
            default() {
                return {};
            }
        },
        selected: String,
        quantity: [Number, String]
    },
    computed: {
        isEmail() {
            return this.selected === this.availableShippingMethods.email.value;
        },
        isGiftBox() {
            return this.selected === this.availableShippingMethods.giftBox.value;
        },
        selectedShipping: {
            get() {
                return this.isEmail
                    ? this.availableShippingMethods.email.value
                    : this.isGiftBox
                    ? this.availableShippingMethods.giftBox.value
                    : this.availableShippingMethods.post.value;
            },
            set(value) {
                this.updateMethod(value);
            }
        },
        providedShippingMethodsArray() {
            return Object.keys(this.shippingMethods).sort();
        },
        actualShippingMethods() {
            return [...this.availableShippingMethods].reduce((final, current) => {
                if (~this.providedShippingMethodsArray.indexOf(current.value)) {
                    final[current.value] = {
                        ...current,
                        text: this.$t(current.text)
                    };
                }
                return final;
            }, {});
        },
        showPackagingOptions() {
            return this.postShippingSelected;
        },
        postShippingSelected() {
            return (
                this.selectedShipping === this.availableShippingMethods.post.value ||
                this.selectedShipping === this.availableShippingMethods.giftBox.value
            );
        },
        showXmasShippingInfo() {
            let today = new Date();
            return (
                this.postShippingSelected && today.getMonth() === 11 && today.getDate() >= 18 && today.getDate() <= 26
            );
        }
    },
    methods: {
        updateMethod(value) {
            this.$emit('update:selected', value);
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;
@use '@/styles/theming' as *;
@use '@/styles/mixins';
@use 'sass:map';

#shippingMethods {
    .top-buttons {
        ::v-deep .btn {
            padding-left: 2 * variables.$grid-padding;
            padding-right: 2 * variables.$grid-padding;
            white-space: nowrap;

            @include mixins.mobile-only {
                padding-left: 1rem;
                padding-right: 1rem;
            }
        }
    }

    .active {
        .item-selected {
            display: block;
        }
    }

    .giftbox-text {
        align-content: space-between;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        ul {
            flex: 1;
        }
    }

    .post-quantity-notice,
    .xmas-notice {
        border: 2px solid hsla(19, 100%, 59%, 0.5);
        padding: 5px 15px;
        margin-bottom: 10px;
        background: hsl(0, 0%, 95%);
    }
}
</style>
